import api from './api';

// Register a new user
export const register = async (userData) => {
  // userData should include { username, email, password, role }
  const response = await api.post('/auth/register', userData);
  // Save token to localStorage for later authenticated requests
  localStorage.setItem('token', response.data.token);
  return response.data; // { user, token }
};

// Login user with credentials
export const login = async (credentials) => {
  // credentials should include { email, password }
  const response = await api.post('/auth/login', credentials);
  localStorage.setItem('token', response.data.token);
  return response.data; // { user, token }
};

// Logout user
export const logout = () => {
  localStorage.removeItem('token');
  return true;
};
